module.exports = __webpack_public_path__ + "static/media/NorthvilleHillsAmendedCCR2011-1.0cb034b5.pdf";